import { createEntityAdapter, createSlice, EntityState } from "@reduxjs/toolkit";
import FileModel from "../../models/FileModel";
import { getFilesByQuery } from "./fileRequests";

export const fileAdapter = createEntityAdapter<FileModel>({
  selectId: (file) => file.id,
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});

type FileState = {
  selectedFileId: number | null;
} & EntityState<FileModel>

const initialState: FileState = {
  selectedFileId: null,
  ...fileAdapter.getInitialState(),
}

export const fileSlice = createSlice({
  name: 'fileSlice',
  initialState,
  reducers: {
    clearCurrentFiles: (state) => {
      state.selectedFileId = null;
      fileAdapter.removeAll(state);
    },
    setCurrentFileId: (state, action) => {
      state.selectedFileId = action.payload;
    }
  },
  extraReducers: builder =>
    builder
      .addCase(getFilesByQuery.fulfilled, (state, action) => {
        fileAdapter.setMany(state, action.payload);
      })
})

export const { setCurrentFileId, clearCurrentFiles } = fileSlice.actions;